import { post, get } from "../config";

export function CreateCheckoutSession(body) {
  return post({ url: "/api/stripe/create-checkout", body });
}

export function SetupRecurring(body) {
  return post({ url: "/api/stripe/setup-recurring", body });
}

export function CancelRecurring(body) {
  return post({ url: "/api/stripe/cancel-recurring", body });
}

export function GetPaymentStatus(sessionId) {
  return get({ url: `/api/stripe/payment-status/${sessionId}` });
}
